<i class="pi pi-exclamation-circle overlay__icon" [class.error]="isError()"></i>
<span class="overlay__text">A system error has occurred and criteria can not be loaded. Please contact your system administrator</span>
